import { render, staticRenderFns } from "./SelectedPointsPanel.vue?vue&type=template&id=f395a85c&scoped=true"
import script from "./SelectedPointsPanel.vue?vue&type=script&lang=js"
export * from "./SelectedPointsPanel.vue?vue&type=script&lang=js"
import style0 from "./SelectedPointsPanel.vue?vue&type=style&index=0&id=f395a85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f395a85c",
  null
  
)

export default component.exports